import React, { useRef, useState } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { parseString } from 'xml2js';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

    },
    grid: {
        width: 500,
        minHeight: 300,
        padding: 20,
        maxWidth: '95%',
        border: '3px dashed white',
        borderRadius: 8,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        position: 'relative',
    },
    gridBgImages: {
        width: '100%',
        position: 'absolute',
        top: 0,
        zIndex: 1
    },
    images: {
        width: '100%'
    },
    gridContent: {
        position: 'relative',
        zIndex: 2,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    fileInput: {
        margin: '10px 0',
        display: 'none',
    },
    output: {
        marginTop: 20,
        whiteSpace: 'pre-wrap',
        textAlign: 'left',
    },
    button: {
        width: 200,
        backgroundColor: '#A0DEFF',
        color: '#1D24CA',
        border: '1px solid white ',
        boxShadow: '1px 1px 10px #A0DEFF',
        '&:hover': {
            backgroundColor: 'white',
            color: '#1D24CA',
            border: '1px solid #1D24CA '
        }
    },
    gridClose: {
        width: '100%',
        textAlign: 'right'
    }
}));

export default function Index() {

    const classes = useStyles();
    const [data, setData] = useState(null);
    const fileInputRef = useRef(null);


    const handleFileUpload = (event) => {

        const file = event.target.files[0];

        if (file && file.type !== 'text/xml' && !file.name.endsWith('.xml')) {
            alert('فقط فایل‌های با فرمت XML قابل بارگذاری هستند.');
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            const xmlStr = e.target.result;
            parseString(xmlStr, (err, result) => {
                if (result?.Letter?.Origins?.[0]?.Origin?.[0]?.['_']) {
                    setData(result?.Letter?.Origins?.[0]?.Origin?.[0]?.['_']);
                } else {
                    alert('در بارگذاری فایل مشکلی به وجود آمده است')
                }
            });
        };

        reader?.readAsText(file); {//eslint-disable-line
        }
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };


    return (
        <div className={classes.root}>
            {
                !data && (
                    <>
                        <div className={classes.grid}>
                            <div className={classes['gridBgImages']}>
                                <img src={'/assets/images/FileUpload.jpg'} alt='' className={classes['images']} />
                            </div>
                            <div className={classes['gridContent']}>
                                <input
                                    type="file"
                                    className={classes.fileInput}
                                    onChange={handleFileUpload}
                                    ref={fileInputRef}
                                    accept=".xml,text/xml"
                                />
                                <Button className={classes['button']} onClick={handleButtonClick}>انتخاب کنید</Button>
                            </div>
                        </div>
                    </>
                )
            }

            {data && (
                <div className={classes.output}>
                    <div className={classes['gridClose']}>
                        <p style={{ cursor: 'pointer' }} onClick={() => setData(null)}>
                            بازگشت
                        </p>
                    </div>
                    <iframe src={`data:application/pdf;base64,${data}`} style={{ width: "70vh", height: "75vh" }} ></iframe> {//eslint-disable-line jsx-a11y/iframe-has-title
                    }
                </div>
            )}

        </div>
    );
}
